import Artwork from "./Artwork";
import { Reveal, Eyebrow } from "./Reveal";
import { CONTENT } from "@/content";

export default function Visuals() {
  return (
    <section id="visuals" data-testid="visuals-section" className="relative py-28 md:py-44 px-6 md:px-16 max-w-[1600px] mx-auto border-t border-white/5">
      <Reveal className="flex items-end justify-between mb-12 md:mb-20">
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-none text-4xl sm:text-6xl lg:text-7xl text-[#f5f3ef]">
          VISUALS
        </h2>
        <Eyebrow className="hidden sm:block">ATMOSPHERE</Eyebrow>
      </Reveal>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
        {CONTENT.visuals.map((v, i) => (
          <Reveal key={v.caption} delay={0.05 * i} className={i % 3 === 1 ? "lg:mt-20" : ""}>
            <figure data-testid={`visual-item-${i}`} className="group">
              <div className="overflow-hidden">
                <Artwork
                  variant={v.variant}
                  image={v.image}
                  alt={v.caption}
                  className={`w-full ${v.ratio} transition-transform duration-[1400ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]`}
                />
              </div>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
